import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import analytics from 'utils/analytics'
import { getUser } from 'services/auth'

/**
 * HACK: this is a hack to make sure that the user info is always set in the
 *       analytics features.
 */
export function useAnalytics() {
  const location = useLocation()

  useEffect(() => {
    const user = getUser()
    if (user) {
      analytics.setUser(user)
    }
  }, [location.pathname])
}
